<app-card-widget title="Emails" *ngIf="invoice$ | async">

  <form [formGroup]="form" id="email-v2-form" (ngSubmit)="save()" *ngIf="usersMap$ | async as usersMap" novalidate>

    <div class="card-section-container">

      <!-- Email list (hidden in add mode) -->
      <div class="card-section" *ngIf="!added">
        <mat-nav-list>
          <mat-list-item *ngFor="let item of emailMessages$ | async" (click)="itemClicked(item)" [class.mat-elevation-z2]="item === selectedItem">
            <mat-icon matListIcon>email</mat-icon>
            <h3 matLine>{{ item.subject }}</h3>
            <span matLine>{{ item.to.join(', ') }}</span>
            <div class="list-item-container">
              <div class="status-label" [ngClass]="getStatusClass(item.status)">{{ item.status }}</div>
              <div class="list-item-timestamp">{{ item.created_at | date:'short' }}</div>
            </div>
          </mat-list-item>
        </mat-nav-list>
      </div>

      <!-- Detail view (selected item, not in add mode) -->
      <div class="card-section" *ngIf="selectedItem && !added">
        <app-text label="Status">{{ selectedItem.status }}</app-text>
        <app-text label="To">{{ selectedItem.to.join(', ') }}</app-text>
        <app-text label="CC" *ngIf="selectedItem.cc?.length > 0">{{ selectedItem.cc.join(', ') }}</app-text>
        <app-text label="BCC" *ngIf="selectedItem.bcc?.length > 0">{{ selectedItem.bcc.join(', ') }}</app-text>
        <app-text label="Subject">{{ selectedItem.subject }}</app-text>
        <app-text label="Message"><pre style="white-space: pre-wrap">{{ selectedItem.content }}</pre></app-text>
        <app-text label="User">{{ usersMap.get(selectedItem.created_by)?.name }}</app-text>
        <app-text label="Created">{{ selectedItem.created_at | date:'medium' }}</app-text>

        <!-- Delivery events timeline -->
        <div *ngIf="selectedItem.events?.length > 0" class="events-section">
          <p class="mat-body-2 events-header">Events</p>
          <div *ngFor="let event of getSortedEvents(selectedItem.events)" class="event-row mat-body-1">
            <span>{{ (event.event_at || event.created_at) | date:'medium' }}</span>
            <span>{{ event.status_type }}</span>
          </div>
        </div>
      </div>

      <!-- Send form -->
      <div class="card-section" *ngIf="added">

        <mat-form-field>
          <mat-select placeholder="Template" formControlName="emailTemplateId" (selectionChange)="templateChange($event)">
            <mat-option [value]="null">No Template</mat-option>
            <mat-option *ngFor="let template of emailTemplates$ | async" [value]="template">
              {{ template.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field>
          <input matInput placeholder="To (required, comma-separated)" formControlName="to"/>
        </mat-form-field>

        <mat-form-field>
          <input matInput placeholder="CC (optional, comma-separated)" formControlName="cc"/>
        </mat-form-field>

        <mat-form-field>
          <input matInput placeholder="BCC (optional, comma-separated)" formControlName="bcc"/>
        </mat-form-field>

        <mat-form-field>
          <input matInput placeholder="Subject" formControlName="subject"/>
        </mat-form-field>

        <mat-form-field>
          <textarea matInput placeholder="Message" formControlName="message" rows="18"></textarea>
        </mat-form-field>
      </div>

      <!-- Attachment selection (in add mode) -->
      <div class="card-section" *ngIf="added">
        <p class="mat-body-2" style="margin-bottom: 0.5rem">Attachments</p>
        <mat-selection-list formControlName="attachmentIds">
          <mat-list-option *ngFor="let attachment of invoiceAttachments$ | async" [value]="attachment.id">
            <h3 matLine>{{ attachment.filename }}</h3>
            <span matLine>{{ attachment.type_description }}</span>
          </mat-list-option>
        </mat-selection-list>
      </div>

    </div>

  </form>

  <mat-card-actions align="end">
    <button type="button" mat-button *ngIf="!added" [disabled]="locked" (click)="add()">Add</button>
    <button type="submit" mat-button *ngIf="added" [disabled]="!form.valid || saving" form="email-v2-form">Send</button>
    <button type="reset" mat-button *ngIf="added" (click)="revert()">Cancel</button>
  </mat-card-actions>

</app-card-widget>
